import { getMiniHostAppDetail } from 'mini-host-bridge/lib/getMiniHostAppDetail';

const VERSIONS_TO_FORCE_UPDATE = ['2.55', '2.57', '2.59', '2.60'];

export const forceVersionUpdateCondition = () => {
    const liteAppDetail = getMiniHostAppDetail();
    return VERSIONS_TO_FORCE_UPDATE.includes(liteAppDetail?.appVersionName);
};
